export default __webpack_public_path__ + "static/media/bg4.2946ae72.png";